import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {Seller} from "./sellers.model";

@Injectable()
export class SellersService {

	constructor(private http: HttpClient) {}

	public createSeller(seller: Omit<Seller, 'id'>): Observable<Seller> {
		return this.http.post<Seller>(`/backoffice/sellers`, seller);
	}

	public getSellerById(id: string): Observable<Seller> {
		return this.http.get<Seller>(`/backoffice/sellers/${id}`);
	}

	public getSellers(): Observable<Seller[]> {
		return this.http.get<Seller[]>(`/backoffice/sellers`);
	}

	public updateSeller(seller: Seller): Observable<Seller> {
		return this.http.put<Seller>(`/backoffice/sellers/${seller.id}`, seller);
	}

	public deleteSeller(seller: Seller): Observable<any> {
		return this.http.delete(`/backoffice/sellers/${seller.id}`);
	}
}
